// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigation{background-color:var(--color-display);height:60px;width:100%;position:fixed;margin:0 -15px;top:0;z-index:107}", ""]);
// Exports
module.exports = exports;
